import { Component, OnInit, AfterViewInit } from '@angular/core';

import { LoginService } from '../auth/login/login.service';
import { ClientTableDataService } from '../table/table.service';
import { DeliveryPipe } from '../../delivery.pipe';
import { DecimalPipe, PercentPipe, CurrencyPipe } from '@angular/common';

@Component({
    selector: 'app-remittancedetail',
    templateUrl: './remittancedetail.component.html',
    styleUrls: ['./remittancedetail.component.scss'],
    imports: [DecimalPipe, PercentPipe, CurrencyPipe, DeliveryPipe]
})
export class RemittanceDetailComponent implements OnInit {

  constructor(
  	private lS: LoginService,
    public tableService: ClientTableDataService
    ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

}
